import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const checkBoxLabelCss = (disableVocabularySupportChecked) => ({
  alignItems: "flex-start",
  maxWidth: "calc(100vw - 72px)",
  width: "344px",
  padding: "0",
  color: disableVocabularySupportChecked ? ui.neutral[700] : ui.neutral[500],
  outlineOffset: "4px",
});

export const containerCss = {
  display: "flex",
  alignItems: "center",
};
